import { textService } from "src/core/services/textService";
import type { Person } from "../../../features/auth/models/personRequestModel";
import { BackendClient } from "../clients/backendClient";
import { authFetch } from "./authFetch";

class EKClient extends BackendClient {
  constructor() {
    super(import.meta.env.VITE_BACKEND_URL, {
      fetch: authFetch,
    });
  }

  protected jsonParseReviver = (_key: string, value: any) => {
    if (
      typeof value === "string" &&
      /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value)
    ) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) return date;
    }
    return value;
  };
}

class BackendService {
  createBackendClient() {
    return new EKClient();
  }

  nullToUndefined(dataModel: any) {
    if (dataModel === null || dataModel === undefined) return;

    const entries = Object.entries(dataModel);
    for (const [key, value] of entries) {
      if (value === null) {
        dataModel[key] = undefined;
      }
    }
    return dataModel;
  }

  personResponseFix(response: Person) {
    response.ssn = textService.formatSSN(response.ssn ?? "");
    response.phone = textService.formatPhone(response.phone ?? "");
  }

  personRequestFix(request: Person) {
    request.name = request.name?.trim();
    request.ssn = request.ssn?.replace(/[-]/g, "");
    request.ssnConsent = (request.ssn?.length ?? 0) > 0;
    request.phone = request.phone?.replace(/[\s+()_\-]/g, "");
  }
}

export const backendService = new BackendService();
